var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',_vm._g(_vm._b({directives:[{name:"draggable",rawName:"v-draggable",value:(_vm.draggableValue),expression:"draggableValue"}],staticClass:"dialogbox"},'div',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }